module.exports = __webpack_public_path__ + "static/media/KW.bea28e05.png";